/* tslint:disable */
/* eslint-disable */
export enum CyklusProduktEnumDto {
  Fyringsolie = 'Fyringsolie',
  Gas = 'Gas',
  El = 'El'
}
